import { ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

import { CameraIcon } from '../Icons/CameraIcon';

interface IProps {
  className?: string;
  placeholderIcon?: ReactNode;
}

export const NextImagePlaceholder = ({
  className = '',
  placeholderIcon = (
    <div className="rounded-sm bg-disabled p-3">
      <CameraIcon />
    </div>
  ),
}: IProps) => (
  <div
    className={twMerge(
      `absolute left-0 top-0 flex h-full w-full items-center justify-center bg-twilight p-4 text-lake-fog`,
      className,
    )}
  >
    {placeholderIcon}
  </div>
);
